// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"152":"5bd6eb76","287":"91a2ba91","297":"4ac6156e","678":"f778b3bb","708":"71763bc3","724":"9d645f7b","914":"3351a6fc"}[chunkId] + ".chunk.css";
};